module.exports = __webpack_public_path__ + "img/.xml.71bb1377.svg";